module.exports = __webpack_public_path__ + "img/icon_album1.e9b9a285.png";